import authRoutes from "@/router/common/authRoutes.ts";
import profileRoutes from "@/router/common/profileRoutes.ts";
import dashboardRoutes from "@/router/dashboardRoutes.ts";
import environmentalPerformanceRoutes from "@/router/environmental-performance/environmentalPerformanceRoutes.ts";
import keyAccountProductRoutes from "@/router/key-account-products/keyAccountProductRoutes.ts";
import publicRoutes from "@/router/publicRoutes.ts";
import repairFileRoutes from "@/router/repair-files/repairFileRoutes.ts";
import restrictedRoutes from "@/router/restrictedRoutes.ts";
import expressistConnexionRoutes from "@/router/transporters/expressistConnexionRoutes.ts";
import usersRoutes from "@/router/usersRoutes.ts";
import { useAuthStore } from "@/stores/authStore.ts";
import PublicLayout from "@/layouts/PublicLayout.vue";

import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  ...authRoutes,
  ...dashboardRoutes,
  ...usersRoutes,
  ...keyAccountProductRoutes,
  ...repairFileRoutes,
  ...environmentalPerformanceRoutes,
  ...publicRoutes,
  ...profileRoutes,
  ...expressistConnexionRoutes,
  ...restrictedRoutes,
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from) => {
  const authStore = useAuthStore();
  const isLoggedIn = authStore.auth.loggedIn;
  const leavingPublic =
    to.meta.requiresAuth && from.meta.layout === PublicLayout && isLoggedIn;
  if (leavingPublic) {
    try {
      await authStore.me();
    } catch {
      return { name: "login" };
    }
    if (!authStore.auth.loggedIn) return { name: "login" };
  }

  if (to.meta.requiresAuth && !isLoggedIn) {
    return { name: "login" };
  }

  if (to.meta.guestOnly && isLoggedIn) {
    return { name: "dashboard" };
  }

  const permissions = to.meta.permissions;
  if (
    Array.isArray(permissions) &&
    permissions.length > 0 &&
    !authStore.hasPermission(permissions as string[])
  ) {
    if (!leavingPublic) {
      try {
        await authStore.me();
      } catch {
        return { name: "login" };
      }
    }

    if (!authStore.hasPermission(permissions as string[])) {
      return { name: "notAuthorized" };
    }
  }

  return true;
});

export default router;
